
const _data = {
  pdfUpload: undefined,
}

function getPdfUpload() {
  return _data.pdfUpload
}

function setPdfUpload(newValue) {
  _data.pdfUpload = newValue

  sessionStorage.setItem('pdfUpload', JSON.stringify(newValue))
}


function init() {
  var curr = undefined

  if ((curr = sessionStorage.getItem('pdfUpload'))) {
    try {
      _data.pdfUpload = JSON.parse(curr)
    }
    catch {
      _data.pdfUpload = undefined
      sessionStorage.setItem('pdfUpload', undefined)
    }
  }
}

init()

export default {
  getPdfUpload,
  setPdfUpload,
}
